import axios, { CancelToken } from "axios";

export class AlertApiHandler {
  lastApiHost = "";

  constructor() {
    this.api = axios.create({
      baseURL: process.env.REACT_APP_ALERT_API_URL,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });

    // this.api.interceptors.request.use((config) => {
    //   const currentUser = authStore.getUser();
    //   const userID = currentUser?.id || currentUser?.userID;

    //   if (userID) {
    //     config.headers["X-User-ID"] = userID;
    //   }

    //   return config;
    // });
  }

  async getHeaders() {
    return { "Content-Type": "application/json" };
  }

  handleErrorCode(error) {
    if (error.response) {
      const { status, data } = error.response;
      const message = data?.message || "An unexpected error occurred.";
      console.error(`Alert API Error (${status}): ${message}`, data);
      throw new Error(message);
    }
    console.error("Alert API Request Error:", error.message);
    throw new Error(error.message);
  }

  async request(method, endpoint, data) {
    try {
      const headers = await this.getHeaders();
      const cancelToken = CancelToken.source();

      const response = await this.api.request({
        method,
        url: endpoint,
        data,
        headers,
        cancelToken: cancelToken.token,
      });

      this.updateLastApiHost(this.api.defaults.baseURL + endpoint);
      return response.data;
    } catch (error) {
      this.handleErrorCode(error);
    }
  }

  updateLastApiHost(url) {
    try {
      this.lastApiHost = new URL(url).host;
    } catch (error) {
      console.error("Error parsing URL:", error);
    }
  }

  getLastApiHost() {
    return this.lastApiHost || "No API request made yet";
  }

  get(endpoint) {
    return this.request("get", endpoint);
  }

  post(endpoint, data) {
    return this.request("post", endpoint, data);
  }

  put(endpoint, data) {
    return this.request("put", endpoint, data);
  }

  delete(endpoint, data) {
    return this.request("delete", endpoint, data);
  }

  patch(endpoint, data) {
    return this.request("patch", endpoint, data);
  }
}

const alertApiHandler = new AlertApiHandler();
export default alertApiHandler;
